import { toast } from 'sonner';

// Consistent toast styling for the entire application
export const toastStyles = {
  success: {
    backgroundColor: '#f0fdf4',
    color: '#16a34a', 
    border: '1px solid #bbf7d0'
  },
  error: {
    backgroundColor: '#fef2f2',
    color: '#dc2626',
    border: '1px solid #fecaca'
  },
  warning: {
    backgroundColor: '#fffbeb',
    color: '#d97706',
    border: '1px solid #fed7aa'
  },
  info: {
    backgroundColor: '#eff6ff',
    color: '#2563eb',
    border: '1px solid #bfdbfe'
  }
};

// Standardized toast notification functions
export const showToast = {
  success: (message: string) => {
    toast.success(message, {
      style: toastStyles.success
    });
  },

  error: (message: string) => {
    toast.error(message, {
      style: toastStyles.error
    });
  },

  warning: (message: string) => {
    toast.warning(message, {
      style: toastStyles.warning
    });
  },

  info: (message: string) => {
    toast.info(message, {
      style: toastStyles.info
    });
  },

  // Specific success patterns
  saved: (entity: string = 'Data') => {
    showToast.success(`${entity} saved successfully`);
  },

  updated: (entity: string = 'Data') => {
    showToast.success(`${entity} updated successfully`);
  },

  deleted: (entity: string = 'Item') => {
    showToast.success(`${entity} deleted successfully`);
  },

  // Specific error patterns
  saveFailed: (entity: string = 'data') => {
    showToast.error(`Failed to save ${entity}`);
  },

  loadFailed: (entity: string = 'data') => {
    showToast.error(`Failed to load ${entity}`);
  },

  deleteFailed: (entity: string = 'item') => {
    showToast.error(`Failed to delete ${entity}`);
  },

  // Validation patterns
  required: (field: string) => {
    showToast.warning(`${field} is required`);
  },

  invalid: (field: string, reason?: string) => {
    const message = reason ? `${field} is invalid: ${reason}` : `${field} is invalid`;
    showToast.warning(message);
  },

  // Constraint handling
  constraintViolation: (entity: string = 'record') => {
    showToast.success(`${entity} updated successfully (existing record was modified)`);
  },

  // Network/database patterns
  networkError: () => {
    showToast.error('Network error. Please check your connection and try again.');
  },

  databaseError: (operation: string = 'operation') => {
    showToast.error(`Database error during ${operation}. Please contact support if this persists.`);
  }
};

// Backward compatibility - direct toast functions with styling
export const toastSuccess = (message: string) => showToast.success(message);
export const toastError = (message: string) => showToast.error(message);
export const toastWarning = (message: string) => showToast.warning(message);
export const toastInfo = (message: string) => showToast.info(message);